$(document).ready(function(){
  $(".tom_cart_product_detail .tom_add_ins_content a.tom_editable_aim").on("click", function(e){
    e.preventDefault();
    var tag_name = $(this).attr('data-tag-name');
    var tag_ki_type = $(this).attr('data-key-input').trim();
    var data_key_item = Number($(this).attr('data-key-item'));
    var InputText = $(this).prev().text().trim().replaceAll(' ','~');
    var validation = false;
    var add_inc_identifyer = false;
    var linked_product_status = false;
  
    console.log('tag_ki_type', tag_ki_type)
    if( InputText.length > 0){
      if(tag_ki_type == 'Add an Inscription'){
        if(tag_name == 'spurs_inscription'){
          if(InputText.length > 40){
            $(this).parent().next().text("Maximum number of characters: 40");
            $(this).parent().next().addClass('active');
          }else{
            validation = true;
            add_inc_identifyer = true;
          }
        }else if(tag_name == 'bits_inscription'){
          if(InputText.length > 20){
            $(this).parent().next().text("Maximum number of characters: 20"); 
            $(this).parent().next().addClass('active');
          }else{
            validation = true;
             add_inc_identifyer = true;
          }
        }
      }else if(tag_ki_type == 'Two Initials'){
        if(InputText.length > 2){
          $(this).parent().next().text("Maximum number of characters: 2");
          $(this).parent().next().addClass('active');
        }else{
          validation = true;
        }
      }else if(tag_ki_type == 'Three Initials'){
        if(InputText.length > 3){
          $(this).parent().next().text("Maximum number of characters: 3");
          $(this).parent().next().addClass('active');
        }else{
          validation = true;
        }
      }else if(tag_ki_type == 'Name'){
        if(InputText.length == ""){
          $(this).parent().next().text("Input must be filled out");
          $(this).parent().next().addClass('active');
        }else{
          validation = true;
        }
      }else if(tag_ki_type == 'Boot Size'){
        if(InputText.length == ""){
          $(this).parent().next().text("Input must be filled out");
          $(this).parent().next().addClass('active');
        }else{
          validation = true;
        }
      }else if(tag_ki_type == "3/16” silver letters ($16 per letter)"){
        console.log('3/16” silver letters ($16 per letter) -- >> Show');
        if(InputText.length > 10){
          $(this).parent().next().text("Maximum number of characters: 10");
          $(this).parent().next().addClass('active');
        }else{
          validation = true;
          linked_product_status = true;
        }
      }
    }else{
      if(tag_ki_type != "3/16” silver letters ($16 per letter)"){
        $(this).parent().next().text("Input must be filled out");
        // $('.crt_ai_error').text("Input must be filled out");
        $(this).parent().next().addClass('active');
      }else{
        validation = true;
        linked_product_status = true;
      }
    }
    
    console.log('validation', validation)
    if(validation){   
      if(linked_product_status){
        var new_obj = {};
        
        var linked_new_qty = Number(InputText.length)
        var linked_product_data = $(this).attr('data-linked-product').trim().replaceAll(' ','~');
        var new_linked_product_data = linked_product_data.split('--')[0] +'--'+ InputText;
        if(linked_new_qty){
          new_obj["silver letters"] = InputText.replaceAll('~',' ');  
        }
        new_obj["_For Product"] = new_linked_product_data;
        console.log(new_obj)
        var linked_key_item = Number($('.tom_editable_aim.special_char[data-old-value="'+linked_product_data+'"]').attr('data-key-item'));
        var linked_list_item = { line: linked_key_item, properties: new_obj , quantity: linked_new_qty};
      }
      
      //console.log( $('.tom_editable_aim').not(this).length);
      $(this).parent().next().removeClass('active');
      
      var my_obj = {}; 
      if(add_inc_identifyer){
        var append_msg = $(this).attr("data-extra-price-label");
        var new_input = $(this).attr('data-key-input');
        var new_value = $(this).prev().text();
        new_value  = new_value +  " |" + append_msg;
      }else{
        var new_input = $(this).attr('data-key-input');
        var new_value = $(this).prev().text();
      }
      // var new_input = $(this).attr('data-key-input');
      // var new_value = $(this).prev().text();
      if(new_input == "3/16” silver letters ($16 per letter)"){
        if(new_value != ""){
          my_obj[new_input] = new_value;
        }
      }else{
        my_obj[new_input] = new_value;
      }
      
      var s = $(this).parents(".cart-item__details").find('.tom_editable_aim').not(this);
      s.each(function(e){
        var data_key_input = $(this).attr("data-key-input");
        var data_key_value= $(this).attr("data-old-value");
        my_obj[data_key_input] = data_key_value;
      });
      if(!Object.keys(my_obj).length){
        my_obj[null]= null
      }
      var list_item = { line: data_key_item, properties: my_obj };
      //console.log(list_item);
  
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(list_item)
      })
      .then((response) => response.json())
      .then((data) => {
        console.log("Update Properties Done");
        console.log(linked_product_status);
        if(linked_product_status){
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify(linked_list_item)
          })
          .then((response) => response.json())
          .then((data) => {
            window.location.href = '/cart'
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        }else{
          console.log('main redirection call')
          window.location.href = '/cart'  
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  
    if(tag_name == 'bits_inscription'){
      if(InputText.length > 20){
        $(this).addClass('saveBtn');
      }else{
        $(this).removeClass('saveBtn');
      }
    }else if(tag_name == 'spurs_inscription'){
      if(InputText.length > 40){
        $(this).addClass('saveBtn');
      }else{
        $(this).removeClass('saveBtn');
      }
    }else if(tag_ki_type == 'two-initials'){
      if(InputText.length > 2){
        $(this).addClass('saveBtn');
      }else{
        $(this).removeClass('saveBtn');
      }
    }else if(tag_ki_type == 'boot-size'){
      if(InputText.length == ""){
        $(this).addClass('saveBtn');
      }else{
        $(this).removeClass('saveBtn');
      }
    }else if(tag_ki_type == '3/16” silver letters ($16 per letter)'){
      if(InputText.length == ""){
        $(this).addClass('saveBtn');
      }else{
        $(this).removeClass('saveBtn');
      }
    }
  });
  // second speical letter product code start
  
  // if( $('.tom_product_detail_content input[name="properties[3/16” silver letters ($16 per letter)]"]').length > 0 ){
    $(document).ajaxComplete(function(event,xhr,settings){
      if(settings.url === "/cart/add"){
        $.getJSON('/cart.json', function(e){
          var silver_qty_length = e.items[0].properties['3/16” silver letters ($16 per letter)'].length || 0;
          var silver_qty_length_char = e.items[0].properties['3/16” silver letters ($16 per letter)']
          var $produc_title = e.items[0].handle +'--'+ silver_qty_length_char
          console.log('silver_qty_length', silver_qty_length)
          if(silver_qty_length > 0){
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: 'quantity=' + silver_qty_length + '&id=' + 41188923342892 +'&properties[_For Product]='+$produc_title+'&properties[silver letters]='+silver_qty_length_char,
              dataType: 'json',
              success: function(line_item) {
                if ((typeof callback) === 'function') {
                  callback(line_item);
                }else {
                  console.log('added');
                }
              },
              error: function(XMLHttpRequest, textStatus) {
                Shopify.onError(XMLHttpRequest, textStatus);
              }
            });
          }
        });
      }
    });
  // }
  
  
  // second speical letter product code end
  // --------------------------------------
  $('.cart_remove_btn').click(function(e){
  e.preventDefault();
  e.stopImmediatePropagation();

  var $sibling_product = $(this).attr('data-product-title');
  // console.log('$sibling_product', $sibling_product);

  var $cart_remove_url = $(this).attr('data-remove-product-url');
  var $cart_remove_item = $(this).attr('data-item-key');

  if ($sibling_product !== undefined) {
    var $sibling_remove_product_url = $('.tom_editable_aim.special_char[data-old-value="' + $sibling_product + '"]').attr('data-p-key');
    var $all_qty = Number($('.tom_editable_aim.special_char[data-old-value="' + $sibling_product + '"]').attr('data-qty'));
    var $sibling_remove_product_qty = Number($sibling_product.split('--')[1].length);
    var $qty_left = $all_qty - $sibling_remove_product_qty;

    var data = { updates: {} };
    data.updates[$cart_remove_item] = 0;

    // console.log('$sibling_remove_product_url', $sibling_remove_product_url);

    if ($sibling_remove_product_url !== undefined) {
      data.updates[$sibling_remove_product_url] = $qty_left;
      // console.log('$sibling_remove_product_url != undefined', $qty_left);

      jQuery.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: data,
        dataType: "json",
        success: function () {
          window.location.reload();
        },
      });
    } else {
      // console.log('normal remove product');
      window.location.href = $cart_remove_url;
    }
  } else {

    // console.log('Updating connected product properties...',);

      var $linkedProduct = $(this).closest('.cart-item').find('.tom_editable_aim.special_char').attr('data-old-value');

      if ($linkedProduct) {  // Proceed only if $linkedProduct is not empty
        // console.log('Linked product:', $linkedProduct);
    
        // Find the cart item that matches the linked product
        var $linkedProductMatched = $('.cart-item').filter(function () {
          return $(this).find('.cart_remove_btn').attr('data-product-title') === $linkedProduct;
        });
    
        if ($linkedProductMatched.length) {  // Check if a matching cart item is found
          // console.log("$linkedProductMatched", $linkedProductMatched);

          var $linkedPropertyJSON = $linkedProductMatched.attr('data-property');

          var propertiesArray = [];
          try {
            propertiesArray = JSON.parse($linkedPropertyJSON.replace(/'/g, '"'));
          } catch (e) {
            console.error('Failed to parse properties JSON:', e);
          }
          
          // Target property to remove
          var propertyToRemove = "3/16” silver letters ($16 per letter)";
          
          // Rebuild properties excluding the one to remove
          var finalProperties = {};
          propertiesArray.forEach(function(prop) {
            if (prop.name !== propertyToRemove) {
              finalProperties[prop.name] = prop.value;
            }
          });
          
          var $linkedEl = $linkedProductMatched.find('.tom_editable_aim').first();
    
          var $linkedKey = $linkedEl.attr('data-key-input');
          var $linkedProductKey = $linkedEl.attr('data-p-key');
          
          if ($linkedKey && $linkedProductKey) {
            var updateData = {
              id: $linkedProductKey,
              quantity: 1,
              properties: finalProperties
            };
          
            updateData.properties[$linkedKey] = '';  // Clear the property value
          
            jQuery.ajax({
              type: "POST",
              url: "/cart/change.js",
              data: updateData,
              dataType: "json",
              success: function () {
                // console.log('Connected product properties updated.!', $cart_remove_url);
                window.location.href = $cart_remove_url;  // Redirect after successful update
              },
              error: function (err) {
                console.error('Failed to update connected product:', err);
              }
            });
          }
        } else {
          // console.log('Not Connected product');
          window.location.href = $cart_remove_url;  // If no connected product, just remove the product
        }
      } else {
        // console.log('No linked product found. Proceeding to remove the product.');
        window.location.href = $cart_remove_url;  // If no linked product, remove the product
      }

    
  }
});

  // --------------------------------------
  $(".tom_add_ins_content p").keypress(function(evt){
    if(evt.keyCode === 13) {
      evt.preventDefault();
    }
    $(this).closest('.tom_add_ins_content').find('.tom_editable_aim').addClass('saveBtn');
  });
  $(".tom_add_ins_content p").bind("cut copy paste",function(e) {e.preventDefault();});
    
  $(window).on("load", function(){
    $(".tom_add_ins_content a").removeClass('saveBtn');
  });
  $('.tom_add_ins_content p').keydown(function(e) {
    if (e.which == 8) {
      $(this).closest('.tom_add_ins_content').find('.tom_editable_aim').addClass('saveBtn');
    }
  });
});